import {
  SMS_OPT_OUT_POLICY_HINT_TEXT
} from 'react/types/constants';

angular.module('gym.grading').controller('SendGradingEventMessageCtrl', ["$scope", "$state", "$stateParams", "$rootScope", "$http", "$timeout", "flash", "loadingAnimation", "GradingStyles", "SendGradingEventMessageService", "ConfirmBulkMessageService", "SmsValidationService", "PushNotificationValidationService", "PushNotificationOptionsService", "AssetLibraryService", "DefaultReplyAddressService", "Templates", "TemplateValidationService", "ReactModal", "gradingEvent", "bulkMessageService", function($scope, $state, $stateParams, $rootScope, $http, $timeout, flash, loadingAnimation, GradingStyles, SendGradingEventMessageService, ConfirmBulkMessageService, SmsValidationService, PushNotificationValidationService, PushNotificationOptionsService, AssetLibraryService, DefaultReplyAddressService, Templates, TemplateValidationService, ReactModal, gradingEvent, bulkMessageService) {
  var contentValid, getEmailSenderAddresses, isEmailSenderEligibleForWarning, isEmailValid, isPushNotificationValid, isSmsValid, loadTemplates, ref, ref1, ref2, ref3, ref4, sender, subjectValid, url;
  $scope.currentStep = 'build';
  $scope.emailSenders = $rootScope.gym.reply_email_addresses;
  $scope.gradingEvent = gradingEvent;
  $scope.bulkMessage = SendGradingEventMessageService.get();
  $scope.pushNotificationRoutes = [
    {
      label: "No preference (open app to Notifications list)",
      value: ''
    }
  ];
  $scope.smsHintText = SMS_OPT_OUT_POLICY_HINT_TEXT;
  $scope.template = {
    channel: 'email',
    reply_address: DefaultReplyAddressService.getDefaultEmail(),
    sms_opt_out_instructions_policy: ((ref = $scope.template) != null ? ref.sms_opt_out_instructions_policy : void 0) || $scope.gym.presented_gym_sms_detail.sms_opt_out_instructions_policy,
    push_notification_route_name: ((ref1 = $scope.template) != null ? ref1.push_notification_route_name : void 0) || ((ref2 = $scope.pushNotificationRoutes[0]) != null ? ref2.value : void 0),
    push_notification_image_url: (ref3 = $scope.template) != null ? ref3.push_notification_image_url : void 0,
    push_notification_image_thumb_url: (ref4 = $scope.template) != null ? ref4.push_notification_image_thumb_url : void 0
  };
  $scope.mobileAppEnabled = function() {
    var ref5;
    return $scope.gym.mobile_app_enabled && ((ref5 = $rootScope.mobileAppMeta) != null ? ref5.push_notifications_feature_enabled : void 0);
  };
  $scope.replyEmails = (function() {
    var i, len, ref5, results;
    ref5 = $scope.emailSenders;
    results = [];
    for (i = 0, len = ref5.length; i < len; i++) {
      sender = ref5[i];
      results.push(sender.email);
    }
    return results;
  })();
  $scope.checkEmailAuthorization = function(email) {
    var isEmailAuthorized;
    isEmailAuthorized = $scope.emailSenders.find(function(item) {
      return item.email === email;
    });
    if (isEmailAuthorized) {
      return isEmailAuthorized.authorized;
    } else {
      return false;
    }
  };
  $scope.loadPushNotificationRoutes = function() {
    return PushNotificationOptionsService.getOptions($scope.gym.id, {}).then(function(data) {
      if (data.length) {
        return $scope.pushNotificationRoutes = $scope.pushNotificationRoutes.concat(data);
      } else {
        return $scope.pushNotificationRoutes = data;
      }
    }).catch(function(error) {
      return flash.error(error);
    });
  };
  $scope.toggleAssetLibrary = function() {
    return AssetLibraryService.open({
      mode: 'select'
    }).then(function(asset) {
      $scope.template.push_notification_image_asset_id = asset.id;
      $scope.template.push_notification_image_url = asset.attached_url;
      return $scope.template.push_notification_image_thumb_url = asset.thumb_url;
    });
  };
  $scope.removeImage = function() {
    $scope.template.push_notification_image_asset_id = null;
    $scope.template_push_notification_image_url = null;
    return $scope.template.push_notification_image_thumb_url = null;
  };
  $scope.previewImage = function() {
    return ReactModal.open({
      component: 'PushNotificationImageModal',
      props: {
        imageUrl: $scope.template.push_notification_image_url,
        replaceImage: $scope.toggleAssetLibrary,
        removeImage: $scope.removeImage
      }
    });
  };
  $scope.loadPushNotificationRoutes();
  $scope.smsPolicyOptions = [
    {
      label: "Add opt-out instructions to all messages",
      value: "add_sms_opt_out_instructions_for_all_contacts"
    },
    {
      label: "Add opt-out instructions for messages sent to cancelled Members only",
      value: "add_sms_opt_out_instructions_for_prospects_and_cancelled_members_only"
    },
    {
      label: "Do not add opt-out instructions to messages",
      value: "add_sms_opt_out_instructions_for_prospects_only"
    }
  ];
  getEmailSenderAddresses = function() {};
  url = `/gyms/${$scope.gym.id}/reply_email_addresses`;
  $http.get(url).then(function(response) {
    if (!$scope.$$phase) {
      return $scope.$apply(function() {
        return $scope.emailSenders = response.data;
      });
    } else {
      return $timeout(function() {
        return $scope.emailSenders = response.data;
      });
    }
  });
  $scope.showEmailVerificationWarning = function(email) {
    var matchingSender;
    matchingSender = $scope.emailSenders.find(function(item) {
      return item.email === email;
    });
    if (matchingSender) {
      return !matchingSender.skip_warning;
    }
  };
  loadTemplates = function() {
    var templatesParams;
    templatesParams = {
      count: 1000,
      'filters[grading_event_templates_only]': true
    };
    return Templates.getList(templatesParams).then(function(templates) {
      return $scope.templates = templates.plain();
    });
  };
  loadTemplates();
  $scope.goToGradingEvent = function() {
    var params;
    params = {
      gradingEventId: $stateParams.gradingEventId
    };
    return $state.go('gym.grading.grading_events.show', params);
  };
  $scope.goToBuildStep = function() {
    return $scope.currentStep = 'build';
  };
  if (!$scope.bulkMessage.recipients.length) {
    $scope.goToGradingEvent();
  }
  $scope.onTemplateChanged = function(template) {
    var base, base1;
    $scope.template = template || {};
    (base = $scope.template).channel || (base.channel = 'email');
    (base1 = $scope.template).reply_address || (base1.reply_address = DefaultReplyAddressService.getDefaultEmail());
    $scope.template.sms_opt_out_instructions_policy = template.sms_opt_out_instructions_policy;
    return $scope.template.push_notification_route_name = template.push_notification_route_name;
  };
  isSmsValid = function() {
    return $scope.template.channel === 'sms' && $scope.gym.sms_enabled && SmsValidationService.isLengthValid($scope.template.content);
  };
  isEmailValid = function() {
    return $scope.template.channel === 'email' && subjectValid() && $scope.gym.custom_emails_enabled && $scope.template.reply_address;
  };
  isPushNotificationValid = function() {
    return $scope.template.channel === 'push_notification' && subjectValid() && PushNotificationValidationService.isLengthValid($scope.template.content);
  };
  $scope.isFreemiumWithoutPaymentMethod = function() {
    return $scope.template.channel === 'sms' && $rootScope.gym.on_freemium && !$rootScope.gym.subscription_payment_method_present && $scope.gym.sms_enabled;
  };
  subjectValid = function() {
    return TemplateValidationService.subjectIsNotEmpty($scope.template.subject);
  };
  contentValid = function() {
    return TemplateValidationService.contentIsNotEmpty($scope.template.content);
  };
  $scope.messageReady = function() {
    $scope.error = SmsValidationService.getErrors($scope.template);
    if ($scope.error) {
      return false;
    }
    if ($scope.isFreemiumWithoutPaymentMethod()) {
      return false;
    }
    return contentValid() && !$scope.template.requires_object && (isSmsValid() || isEmailValid() || isPushNotificationValid());
  };
  $scope.hasSelectedRecipients = function() {
    return _.findWhere($scope.bulkMessage.recipientList, {
      selected: true
    });
  };
  $scope.pluralMessageType = function() {
    return bulkMessageService.pluralMessageType($scope.template.channel, $scope.bulkMessage.recipientList);
  };
  $scope.submitTemplate = function() {
    loadingAnimation.show();
    if ($scope.template.push_notification_route_name === '') {
      $scope.template.push_notification_route_name = null;
    }
    if ('push_notification_image_url' in $scope.template) {
      delete $scope.template.push_notification_image_url;
    }
    if ('push_notification_image_thumb_url' in $scope.template) {
      delete $scope.template.push_notification_image_thumb_url;
    }
    getEmailSenderAddresses();
    $scope.bulkMessage.template = $scope.template;
    return bulkMessageService.set($scope.bulkMessage).then(function() {
      loadingAnimation.hide();
      return $scope.currentStep = 'confirm';
    });
  };
  $scope.openUnverifiedEmailSenderWarningModal = function(email, submitFunction) {
    return ReactModal.open({
      component: 'UnverifiedEmailSenderWarningModal',
      props: {
        unverifiedEmailAddress: email,
        onSubmit: submitFunction
      }
    });
  };
  $scope.confirmTemplate = function() {
    if (isEmailSenderEligibleForWarning($scope.template)) {
      $scope.openUnverifiedEmailSenderWarningModal($scope.template.reply_address, function() {
        return $scope.submitTemplate($scope.template);
      });
    } else {
      return $scope.submitTemplate($scope.template);
    }
  };
  isEmailSenderEligibleForWarning = function(template) {
    return template.channel === 'email' && !$scope.checkEmailAuthorization(template.reply_address) && $scope.showEmailVerificationWarning(template.reply_address);
  };
  return $scope.sendMessage = function() {
    return ConfirmBulkMessageService.confirm($scope.bulkMessage, $rootScope.gym).then(function() {
      loadingAnimation.show();
      return SendGradingEventMessageService.send().then(function() {
        flash.success = 'Messages were sent successfully';
        SendGradingEventMessageService.clear();
        return $scope.goToGradingEvent();
      }, function() {
        flash.error = 'Sorry, the messages could not be sent';
        return loadingAnimation.hide();
      });
    });
  };
}]);
